export default "__VITE_ASSET__BqO0L5dn__"